import React from 'react';
import ImageWithPlaceholder from './image-with-placeholder'

import '../css/free-shipping-banner.less';

const disableBanner = {
    display: 'none'
};

class FreeShippingBanner extends React.Component {

    state = {
        disabled: false
    };

    closeBanner = () => {
        this.setState({disabled: true});
        window.sessionStorage.setItem("disableFloatingBanner",true);
    }

    render(){
        const disabledBanner = window.sessionStorage && ("disableFloatingBanner" in window.sessionStorage);
        const floatingBanner = (<div className='floating-shipping-banner floating' style={this.state.disabled ? disableBanner : null}>
                <div className='icon-container'>
                    <span className='close-banner' onClick={this.closeBanner}>
                        <ImageWithPlaceholder className='close-foating-banner-logo' src='https://store.hp.com/wcsstore/hpusstore/Treatment/category/images/close-icon.png' alt='' />
                    </span>
                    <ImageWithPlaceholder className='cart-logo' src='https://store.hp.com/wcsstore/hpusstore/Treatment/category/images/free-shipping-icon.png' alt='cart'/>
                </div>
                <div className='content'>
                    <div className='medium-title'>Free Next Business Day Delivery <br/> on Ink & Toner</div>
                </div>
            </div>);

        return !disabledBanner ? floatingBanner : null;

    }
}

export default FreeShippingBanner;
